import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8.251 14.701a.85.85 0 01-1.202 0l-5.1-5.1a.85.85 0 010-1.202l5.1-5.1A.85.85 0 018.25 4.501L4.602 8.15h9.848a.85.85 0 010 1.7H4.602l3.649 3.649a.85.85 0 010 1.202z" fill="currentColor" /></svg>);